<template>
  <div>
    <div class="yCenter font-weight-bold">
      <div class="mx-2">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              class="select-documents font-weight-bold white thinText--text"
              v-on="on"
              depressed
              outlined
              height="32px"
            >
              {{ $t('common.common_bulk-operation') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, i) in getBulkOperationItemList()"
              :key="i"
              :class="item.type === 'cancel' ? 'list-item-cancel' : ''"
              @click="clickBulkOperationItem(item.type)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(item.title) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <DepositBulkOperationDialog
        :visible.sync="deposit.dialog"
        :items="items"
        :historyList="historyList"
      />

      <!-- <NormalButton
        class="btnStyle ml-2 mr-4"
        btnClass="pa-0"
        text="出庫操作"
        height="32px"
        @click="submit()"
      /> -->

      <SaleCompleteBulkOperationDialog
        :visible.sync="complete.dialog"
        :items="items"
        :historyList="historyList"
      />
      <BulkOperationDocunents @submit="submit" />

      <!-- <CompleteDialog
        v-model="complete"
        @complete="completeMethod"
        title="aaaaaaaaaaa"
      /> -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import NormalButton from '@/components/items/Buttons/NormalButton'
import {
  DepositBulkOperationDialog,
  SaleCompleteBulkOperationDialog
} from '@/components/layouts/Dialogs'
import BulkOperationDocunents from './BulkOperationDocunents'

export default {
  components: {
    NormalButton,
    DepositBulkOperationDialog,
    SaleCompleteBulkOperationDialog,
    BulkOperationDocunents
    // CompleteDialog
  },
  props: {
    items: [],
    historyList: []
  },
  data: () => ({
    statusHistoryDialog: false,
    deposit: { dialog: false },
    complete: {
      dialog: false
    }
  }),
  methods: {
    ...mapActions('Sale', ['bulkCancelSale']),
    ...mapActions('Common', ['setIsLoading']),
    submit(type) {
      const ids = this.items.filter((d) => d.checkFlg)
      if (!ids.length) {
        return
      }
      this.$emit('onClickLedgerSheet', type, ids)
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getCustomerrName(id) {
      return id
    },
    getUserName(id) {
      return id
    },
    getAmount(id) {
      return this.items.productMoves.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.quantity * currentValue.price
          return accumulator + count
        },
        0
      )
    },

    completeMethod() {
      alert(this.$t('sale.sale_completion-date') + this.complete.dialog.date)
      // ここに登録処理
      // ...

      this.complete.dialog.dialog = false
    },
    getBulkOperationItemList() {
      if (this.authority.isAdmin) {
        return [
          {
            title: this.$t('payment.payment_sale-payment-operate'),
            type: 'deposit'
          },
          {
            title: this.$t('sale.sale_sale-operation'),
            type: 'complete'
          },
          {
            title: this.$t('user.user_cancel'),
            type: 'cancel'
          }
        ]
      }
      return []
    },
    async clickBulkOperationItem(type) {
      if (type === 'deposit') {
        this.deposit.dialog = true
      } else if (type === 'complete') {
        this.complete.dialog = true
      } else if (type === 'cancel') {
        this.cancel()
      }
    },
    async cancel() {
      const checkedItems = this.items.filter((item) => item.checkFlg)
      if (checkedItems.length === 0) {
        alert(this.$t('payment.payment_sale-not-selected'))
        return
      }

      const isConfirmed = confirm(this.$t('sale.sale_sale-cancel-confirm'))
      if (!isConfirmed) {
        return
      }
      this.setIsLoading(true)

      const saleList = []
      checkedItems.forEach((item) => {
        saleList.push({
          saleId: item.id
        })
      })
      const errors = await this.bulkCancelSale({ saleList })

      if (!errors) {
        this.setIsLoading(false)
        return
      }

      const ids = Object.keys(errors)
      if (ids.length === 0) {
        // 成功
        alert(this.$t('common.common_canceled-alert'))
      } else {
        let alertText = ''
        checkedItems.forEach((item) => {
          alertText += this.$t('sale.sale_sale-number')
          const history = this.historyList.filter((history) => {
            return history.saleId === item.id
          })[0]
          alertText += `${history.transaction.controlNumber}:`
          const id = ids.filter((id) => {
            return Number(id) === item.id
          })
          if (id.length > 0) {
            // エラー
            alertText += errors[id[0]]
          } else {
            // 成功
            alertText += this.$t('common.common_canceled-alert')
          }
          if (history !== checkedItems[checkedItems.length - 1]) {
            alertText += '\n'
          }
        })
        alert(alertText)
      }

      this.setIsLoading(false)
      // アラート確認後はリロード
      this.$router.go({
        path: this.$router.currentRoute.path,
        force: true
      })
    }
  },
  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style lang="scss" scoped>
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.select-documents {
  width: 60px;
  height: 32px !important;
  font-size: 12px;
  border: thin solid #c8cfd7 !important;
}
.list-item-cancel {
  border-top: 1px solid #d8d8d8;
}
</style>
